import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import {
	ChevronLeft as ChevronLeftIcon,
	ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";

const COLORS = {
	brown: "#674934",
	border: "#D9CFC7",
	placeholder: "#E9E4DE",
};

const ImageCarousel = ({ images = [], title = "" }) => {
	const [currentIndex, setCurrentIndex] = useState(0);

	if (!images || images.length === 0) {
		return (
			<Box
				sx={{
					width: "100%",
					height: { xs: 220, md: 400, lg: 500 },
					backgroundColor: COLORS.placeholder,
					borderRadius: 2,
				}}
			/>
		);
	}

	const goToPrevious = () => {
		setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
	};

	const goToNext = () => {
		setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
	};

	return (
		<Box
			sx={{
				position: "relative",
				width: "100%",
				height: { xs: 220, md: "auto", lg: "auto" },
				aspectRatio: { xs: "auto", md: "auto", lg: "auto" },
				minHeight: { xs: 220 },
				borderRadius: 2,
				overflow: "hidden",
				backgroundColor: COLORS.placeholder,
				backgroundImage: `url(${images[currentIndex]})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			{/* Only show arrows if there are multiple images */}
			{images.length > 1 && (
				<>
					<IconButton
						onClick={goToPrevious}
						sx={{
							position: "absolute",
							left: 8,
							top: "50%",
							transform: "translateY(-50%)",
							backgroundColor: COLORS.brown,
							color: "#fff",
							width: 36,
							height: 36,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							zIndex: 2,
							padding: 0,
							"&:hover": {
								backgroundColor: COLORS.brown,
								opacity: 0.8,
							},
						}}
					>
						<ChevronLeftIcon sx={{ fontSize: 20 }} />
					</IconButton>

					<IconButton
						onClick={goToNext}
						sx={{
							position: "absolute",
							right: 8,
							top: "50%",
							transform: "translateY(-50%)",
							backgroundColor: COLORS.brown,
							color: "#fff",
							width: 36,
							height: 36,
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							zIndex: 2,
							padding: 0,
							"&:hover": {
								backgroundColor: COLORS.brown,
								opacity: 0.8,
							},
						}}
					>
						<ChevronRightIcon sx={{ fontSize: 20 }} />
					</IconButton>
				</>
			)}
		</Box>
	);
};

export default ImageCarousel;
